export default "__VITE_ASSET__uZyzfa1z__"